import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { DocumentIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import InfoIcon from '@mui/icons-material/Info';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ArticleIcon from '@mui/icons-material/Article';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { DocsTab } from './DocsTab';
import { FeedbackTab } from './FeedbackTab';
import { ContentTab } from './ContentTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'content', label: 'Content', icon: ArticleIcon },
  { id: 'docs', label: 'Docs', icon: DocumentIcon },
  { id: 'feedback', label: 'Feedback', icon: FeedbackIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const ContentEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'content' && <ContentTab />}
        {activeTab === 'docs' && <DocsTab />}
        {activeTab === 'feedback' && <FeedbackTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
